const isMobile = () => window.matchMedia('(max-width: 639px)').matches
const isNotDesktop = () => window.matchMedia('(max-width: 1279px)').matches

export default isMobile
export { isNotDesktop }
